import { title } from "process"

export interface Options {
    "tenantId": number
    "title": string
    "order": number
    "id": number
    "links": Array<Links>
    result? : string
    checked? : boolean
  }
  
  
  
  export interface Links {
    "sourceId": number,
    "tenantId": number,
    "tipDestinationTipId": number,
    "popupDestinationId": number,
    "questionDestinationId": number,
    "actionDestinationId": number,
    "criticity": number,
    "conditionType": number,
    "conditionMinValue": number,
    "conditionMaxValue": number,
    "id": number
  }
  
  export interface Question {
    "tenantId": number
    "title": string
    "userVariableId": number
    "unit": string
    "type": number
    "displayMode": number
    "displayDateMode": number
    "displayLengthOfTimeMode": number
    "allowDecimal": boolean
    "minValue": number
    "maxValue": number
    "minLabel": number
    "maxLabel": number
    "isFirstOfSurvey": boolean
    "id": number
    "options": Array<Options>
    result?: string
  }

  

  export interface SurveyAnswer {
    "surveyId": number
    "date": Date
    "answersQuestions" : Array<AnswersQuestions>
  }



  export interface AnswersQuestions {
    "QuestionId": number
    "Title": string
    "Unit": string
    "Type": number
    "DisplayMode": number
    "DisplayDateMode": number
    "DisplayLengthOfTimeMode": number
    "AnswerOptions": Array<AnswersOptions>
    "TemporaryId": string
  }

  export interface AnswersOptions {
    "OptionId": string
    "Title": string
    "Value": string
    "AnswerLinks": Array<AnswersLinks>   
  }

  export interface AnswersLinks {
    "SurveyLinkId": string
    "tipDestinationId": number
    "popupDestinationId": number
    "surveyActionDestinationId": number
    "criticity": number
    "AnswerQuestionTemporaryId": string    
    "QuestionId": number
  }
  export interface Popup {
    "id"?: number,
    "surveyPopupId": number,
    "tenantId": number,
    "popupContent": string,
    "popupTitle": string,
    "type": number
  }

  export interface Tip{
    "id": number,
    "tenantId" : number,
    "content": string,
    "resume": string,
    "title": string,
    "version": number,
    "patientTip" : PatientTip,
    "category": TipCategory,
    "url": string

  }
  export interface PatientTip{
    "tenantId": number,
    "tipId": number,
    "isFavorite": boolean,
    "isPriority": boolean,
    "isRead": boolean,
    "nbRead": number,
  }

  export interface TipCategory{
    "id": number,
    "name": string,
    "description": string,
    "tenantId": number,
    "url": string,
  }

  export interface DialogData{
    "id" : number,
    "title": string,
    "content" : string,
    "type"? : number,
    "url"?: string,
  }

export interface Survey {
  
  id?: number;
  title?: string,
  questions?: Array<Question>,
  popups: Array<Popup>
  finish?: boolean
}
  export const TIPS:Array<Tip> = [
    {
      "id": 1,
      "tenantId": 3,
      "content": "Félicitations pour votre inscription ! Nous sommes heureux de vous compter parmi nous !\r\n\r\nVous trouverez sur l'écran d'accueil, toutes les actions que vous devrez mener ou suivre : vos rendez-vous, les questionnaires auxquels vous devrez apporter des réponses, des actualités, vos challenges, les conseils que nous vous enverrons, etc.\r\n\r\nLes autres entrées de menu vous permettent d'accéder :\r\n\r\n\tPROFIL : à vos informations personnelles et les paramètres de votre application\r\n\tSUIVI : aux courbes de votre activité\r\n\tMESSAGERIE : à l'interface de discussion avec votre équipe médicale\r\n\tFORUM : à l'interface d'échange et de partage entre pairs\r\n\t\r\nPour toute question n'hésitez pas à vous rendre sur notre site pour nous contacter : https://www.hospitalandme.com",
      "resume": "Nous vous souhaitons la bienvenue dans la solution ho&me.",
      "title": "Bienvenue dans la solution Ho&Me",
      "version": 1,
      "patientTip": {
          "tenantId": 2,
          "tipId": 1,
          "isFavorite": false,
          "isPriority": false,
          "isRead": false,
          "nbRead": 0
      },
      "category": {
          "name": "Autres",
          "description": null,
          "tenantId": 3,
          "url": "https://www.notretemps.com/cache/com_zoo_images/c9/nom-chiot_6d24a44af72d79896fcaf95494afbff4.jpg",
          "id": 34
      },
      "url": "https://www.notretemps.com/cache/com_zoo_images/c9/nom-chiot_6d24a44af72d79896fcaf95494afbff4.jpg"
    }
  ]